export const GET_SUBSCRIPTION_PLAN_REDUCER = 'GET_SUBSCRIPTION_PLAN_REDUCER';
export const GET_SUBSCRIPTION_PLAN_REQUEST = 'GET_SUBSCRIPTION_PLAN_REQUEST';

export const SET_AUTO_RENEW_SUBSCRIPTION_PLAN_REDUCER = 'SET_AUTO_RENEW_SUBSCRIPTION_PLAN_REDUCER';
export const SET_AUTO_RENEW_SUBSCRIPTION_PLAN_REQUEST = 'SET_AUTO_RENEW_SUBSCRIPTION_PLAN_REQUEST';